
import { createReducer, on } from '@ngrx/store';
import { loadForm, saveForm, updateForm } from './formArticle.actions';

export interface FormState {
    formArticle:{
        data:{}
    }
}

export const initialFormState: FormState = {
    formArticle:{
        data:{}
    }
};

export const formArticleReducer = createReducer(
    initialFormState,

    on(loadForm, (state) => ({ ...state, loading: true })),

    on(saveForm, (state) => ({ ...state, loading: true })),

    on(updateForm, (state, data) => ({
        ...state,
        data
    }))
);